import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { evaluationsManager, type IEvaluation } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { EVALUATION_MODULE } from './module';

const dataObjectModule = getDataObjectsModule<IEvaluation>(evaluationsManager, 3);
const searchModule = getSearchModule<IEvaluation>(evaluationsManager);

const evaluationModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(EVALUATION_MODULE, evaluationModuleInstance);

export { EVALUATION_MODULE };
